import { lazy } from 'react'
const PosApprovals = lazy(() => import('../screens/PosApprovals'))
const ApprovedPos = lazy(() => import('../screens/ApprovedPos'))
const BulkMerchantPayoutConfig = lazy(() => import('../screens/BulkMerchantPayoutConfig'))
const AddUpdateUser = lazy(() => import('../screens/AddUpdateUser/'))
const AddUpdateGroup = lazy(() => import('../screens/AddUpdateGroup/'))
const CardMapping = lazy(() => import('../screens/CardMapping/'))
const BankingCodes = lazy(() => import('../screens/BankingCodes/'))
const Devices = lazy(() => import('../screens/Devices/'))
const EmsDevices = lazy(() => import('../screens/EMSDevices/'))
const EntityApprovals = lazy(() => import('../screens/EntityApprovals/'))
const EntityMaster = lazy(() => import('../screens/EntityMaster/'))
const FileUpload = lazy(() => import('../screens/FileUpload/'))
const MerchantMapping = lazy(() => import('../screens/MerchantMapping/'))
const NetbankingMapping = lazy(() => import('../screens/NetbankingMapping/'))
const Package = lazy(() => import('../screens/Package/'))
const PackageToInstrument = lazy(() => import('../screens/PackageToInstrument/'))
const PackageToMId = lazy(() => import('../screens/PackageToMId/'))
const DynamicRouting = lazy(() => import('../screens/DynamicRouting/'))
const RoutingApprovals = lazy(() => import('../screens/RoutingApprovals/'))
const RoutingRules = lazy(() => import('../screens/RoutingRules/'))
const SystemControlConfigApprovals = lazy(() => import('../screens/SystemControlConfigApprovals/'))
const Users = lazy(() => import('../screens/Users/'))
const BulkMerchantOnboarding = lazy(() => import('../screens/BulkMerchantOnboarding/'))
const SearchMerchant = lazy(() => import('../screens/SearchMerchant'))
const EntityManagement = lazy(() => import('../screens/EntityManagement'))
const BulkMerchantMapping = lazy(() => import('../screens/BulkMerchantMapping'))
const EssControlUpdate = lazy(() => import('../screens/EssControlUpdate/'))
const MerchantConfig = lazy(() => import('../screens/MerchantConfig/'))
const LedgerMapping = lazy(() => import('../screens/LedgerMapping/'))
const BulkLedgerMapping = lazy(() => import('../screens/BulkLedgerMapping'))
const PayoutConfig = lazy(() => import('../screens/PayoutConfig'))
const SourceAccountConfig = lazy(() => import('../screens/SourceAccountConfig'))
const RiskConfig = lazy(() => import('../screens/RiskConfig'))
const PayoutCmsUpdate = lazy(() => import('../screens/PayoutCmsUpdate'))
const FeePackage = lazy(() => import('../screens/FeePackage/'))
const FeePackageFileUpload = lazy(() => import('../screens/FeePackageFileUpload/'))
const FeePackageToMId = lazy(() => import('../screens/FeePackageToMId/'))
const FeePackageApprovals = lazy(() => import('../screens/FeePackageApprovals/'))
const ProcessingEntity = lazy(() => import('../screens/ProcessingEntity/'))
const MerchantPayoutConfigApprovals = lazy(() => import('../screens/MerchantPayoutConfigApprovals/'))
const OnHoldSettlements = lazy(() => import('../screens/OnHoldSettlements'))
const CreditAdjustment = lazy(() => import('../screens/CreditAdjustment'))
const OnboardEntity = lazy(() => import('../screens/EntityOnboarding/OnboardEntity'))
const MyOnboardedEntityQueue = lazy(() => import('../screens/EntityOnboarding/MyOnboardedEntityQueue'))
const MyOnboardedEntityDetails = lazy(() => import('../screens/EntityOnboarding/MyOnboardedEntityDetails'))
const CheckerQueue = lazy(() => import('../screens/EntityOnboarding/CheckerQueue'))

const EmsApprovals = lazy(() => import('../screens/EmsApprovals'))
const BulkEssUpdate = lazy(() => import('../screens/BulkEssUpdate'))
//const CreditAdjustmentApprovals = lazy(() => import('../screens/CreditAdjustmentApprovals'))

// const checkerMenu = () => {
//   return [
//     {
//       name: 'Checker Queue',
//       path: '/',
//       icon: 'SETTING',
//       subRights: [
//         {
//           name: 'Global Queue',
//           path: '/checkerGlobalQueue',
//         },
//         {
//           name: 'My Queue',
//           path: '/checkerMyQueue',
//         },
//       ],
//     },
//   ]
// }

// const makerMenu = () => {
//   return [
//     {
//       name: 'Maker Queue',
//       path: '/',
//       icon: 'SETTING',
//       subRights: [
//         {
//           name: 'My Queue',
//           path: '/makerMyQueue',
//         },
//       ],
//     },
//   ]
// }

// const getBulkProcessing = () => {
//   return [
//     {
//       name: 'Bulk Processing',
//       path: 'bulkProcessing',
//       icon: 'SETTING',
//       subRights: [
//         {
//           name: 'Create Bulk Entities',
//           path: '/createBulkEntities',
//         },
//         {
//           name: 'Sync Bulk Entities with MAS',
//           path: '/createTID',
//         },
//       ],
//     },
//   ]
// }

export const menuItems = [
  {
    name: 'Entity Config',
    path: '/',
    icon: 'BANK',
    subRights: [
      {
        name: 'Add/View',
        path: '/entitymaster',
      },
      {
        name: 'Configuration',
        path: '/entityconfigurations',
      },
      {
        name: 'Approvals/Audit',
        path: '/approvals',
      },
    ],
  },
  {
    name: 'Merchant - Processor Configuration',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Merchant Mapping',
        path: '/merchantmapping',
      },
      {
        name: 'Merchant Mapping Approvals',
        path: '/merchantMappingApprovals',
      },
      {
        name: 'Bulk Merchant Mapping',
        path: '/createbulkmerchantmapping',
      },
      {
        name: 'Bulk Merchant Mapping Approvals',
        path: '/approvebulkmerchantmapping',
      },
      {
        name: 'Bulk Key Exchange',
        path: '/createbulkkeyexchange',
      },
    ],
  },
  {
    name: 'Device Management',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Voicebox Devices',
        path: '/devices',
      },
      {
        name: 'POS Devices',
        path: '/emsdevices',
      },
      {
        name: 'View/Add Device Variant',
        path: '/viewAndAddDevices',
      },
      {
        name: 'View/Add Device Plans',
        path: '/viewAndAddDevicePlans',
      },
      {
        name: 'Onboard Devices',
        path: '/onboardDevices',
      },
      {
        name: 'Pair/Unpair SQR',
        path: '/pair-unpair-sqr',
      },
      {
        name: 'Bulk Device Whitelisting',
        path: '/createBulkDeviceUpdate',
      },
    ],
  },
  {
    name: 'Smart Routing',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Define Package',
        path: '/createpackage',
      },
      // {
      //   name: 'Package To Instrument',
      //   path: '/packageinstrument',
      // },
      {
        name: 'MID - Package Mapping',
        path: '/packagemid',
      },
      // {
      //   name: 'Rules',
      //   path: '/routingrules',
      // },
      // {
      //   name: 'Generate Excel File',
      //   path: '/generateExcelFile',
      // },
      {
        name: 'Package Upload',
        path: '/fileupload',
      },
      {
        name: 'Approvals',
        path: '/routingapprovals',
      },
      {
        name: 'Dynamic Routing',
        path: '/dynamicrouting',
      },
    ],
  },
  {
    name: 'Access Control',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Add/View Users',
        path: '/users',
      },
    ],
  },
  {
    name: 'Post Recon Payout',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Approve/Release Payouts',
        path: '/postRecon',
      },
    ],
  },
  {
    name: 'System Configuration',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Codes',
        path: '/bankingcodes',
      },
      {
        name: 'Approvals',
        path: '/systemconfigapprovals',
      },
      {
        name: 'Add/Update MCC',
        path: '/createBulkMCCLov',
      },
      {
        name: 'Add/Update IFSC',
        path: '/createBulkIfscLov',
      },
      {
        name: 'Add/Update Pincode',
        path: '/createBulkPincodeLov',
      },
      {
        name: 'Add/Update Program Category',
        path: '/createBulkProgramCategoryLov',
      },
    ],
  },
  {
    name: 'Aadhaar Redaction',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Aadhaar Redaction',
        path: '/aadharRedaction',
      },
      { name: 'Aadhaar Checker Queue', path: '/aadharCheckerQueue' },
      { name: 'Aadhaar Maker Queue', path: '/aadharMakerQueue' },
      { name: 'Aadhaar details', path: '/aadharRedactionDetails' },
    ],
  },
  {
    name: 'Management',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Search Entity Hierarchy/TID',
        path: '/searchEntityHierarchy',
      },
      {
        name: 'Create Group',
        path: '/createEntityGroup',
      },
      {
        name: 'Create Subgroup',
        path: '/createEntitySubGroup',
      },
      {
        name: 'Create Single Entity',
        path: '/createSingleEntity',
      },
      {
        name: 'My Queue - Checker',
        path: '/checkerMyQueue',
      },
      {
        name: 'Global Queue - Checker',
        path: '/checkerGlobalQueue',
      },
      {
        name: 'My Queue - Maker',
        path: '/makerMyQueue',
      },
      {
        name: 'Bulk Add Users',
        path: '/createBulkUsers',
      },
    ],
  },
  {
    name: 'Onboarding',
    path: '/',
    icon: 'SETTING',
    subRights: [
      { name: 'Onboard Entity', path: '/onboardEntity' },
      { name: 'My Queue - Maker', path: '/makerMyEntityQueue' },
      { name: 'My Queue - Checker 1', path: '/checker1MyQueue' },
      { name: 'My Queue - Checker 2', path: '/checker2MyQueue' },
      { name: 'My Onboarded Entity Details', path: '/myOnboardedEntityDetails' },
      { name: 'Queue - Checker 1', path: '/checker1Queue' },
      { name: 'Queue - Checker 2', path: '/checker2Queue' },
      { name: 'Checker details', path: '/checkerDetails' },
      { name: 'Incidents', path: '/onboardingIncidents' },
      { name: 'IncidentDetails', path: '/onboardingIncidentDetails' },
      { name: 'Global SearchEntity List', path: '/globalSearchEntityList' },
      { name: 'Global SearchEntity Details', path: '/globalSearchEntityDetails' },
    ],
  },
  {
    // Under Risk & Compliance (risk maker/checker onboarding queues).
    name: 'Entity Onboarding',
    path: '/',
    icon: 'SETTING',
    subRights: [
      { name: 'My Queue - Checker', path: '/riskCheckerMyQueue' },
      { name: 'My Queue - Maker', path: '/riskMakerMyQueue' },
      { name: 'Queue - Checker', path: '/riskCheckerQueue' },
      { name: 'Queue - Maker', path: '/riskMakerQueue' },
    ],
  },
  {
    name: 'Bulk Processing',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Add Entities',
        path: '/createBulkEntities',
      },
      {
        name: 'Add Configs',
        path: '/createBulkConfig',
      },
      {
        name: 'Add Card Configs',
        path: '/createBulkCards',
      },
      {
        name: 'Create VPA',
        path: '/createBulkVpa',
      },
      {
        name: 'Store Onboarding',
        path: '/createBulkStore',
      },
      {
        name: 'Terminal Onboarding',
        path: '/createBulkTerminal',
      },
      {
        name: 'Terminal Update',
        path: '/createBulkTerminalUpdate',
      },
      {
        name: 'Entity Update',
        path: '/createBulkStoreUpdate',
      },
      {
        name: 'Checker1 Bulk Claim',
        path: '/checker1BulkClaim',
      },
      {
        name: 'Checker2 Bulk Claim',
        path: '/checker2BulkClaim',
      },
      {
        name: 'Checker1 Bulk Action',
        path: '/checker1BulkAction',
      },
      {
        name: 'Checker2 Bulk Action',
        path: '/checker2BulkAction',
      },
    ],
  },
  {
    name: 'FIU Compliance',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Manage FIU Audits',
        path: '/fiuCompliance',
      },
      { name: 'FIU Queue - Checker', path: '/fiuQueue' },
      { name: 'FIU Queue - Maker', path: '/fiuMakerQueue' },
    ],
  },
  {
    name: 'System Settings',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Payout Frequency',
        path: '/payoutconfig',
      },
      {
        name: 'Source Account',
        path: '/sourceaccountconfig',
      },
      {
        name: 'Payout Processor',
        path: '/processingentity',
      },
    ],
  },
  {
    name: 'Adjustments',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Credit/Debit Adjustment',
        path: '/creditdebitadjustment',
      },
      {
        name: 'Approvals',
        path: '/emsapprovals',
      },
      {
        name: 'Bulk Approvals',
        path: '/essbulkapprovals',
      },
    ],
  },
  {
    name: 'Update Records',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Payout CMS Update',
        path: '/updatepayoutcms',
      },
      {
        name: 'Bulk Payout CMS Update',
        path: '/updatebulkpayoutcms',
      },
    ],
  },
  {
    name: 'Entity Transactions',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'F&R Actions',
        path: '/fAndRAction',
      },
      {
        name: 'F&R Audit Trail',
        path: '/fAndRAudit',
      },
    ],
  },
  {
    name: 'Fee Package',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Package Upload',
        path: '/feepackagefileupload',
      },
      {
        name: 'Approvals/Audit',
        path: '/feepackageapprovals',
      },
    ],
  },
  {
    name: 'Payout Configurations',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'Configuration Update',
        path: '/merchantconfig',
      },
      {
        name: 'Bulk Configuration Update',
        path: '/bulkmerchantpayoutconfig',
      },
      // {
      //   name: 'View Dynamic Hold Settlements',
      //   path: '/onholdsettlements',
      // },
      {
        name: 'Configuration Update Approvals',
        path: '/merchantpayoutconfigapprovals',
      },
      {
        name: 'Bulk Configuration Update Approvals',
        path: '/bulkmerchantpayoutconfigapprovals',
      },
    ],
  },
  {
    name: 'POS',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'View POS',
        path: '/viewpos',
      },
      {
        name: 'Batch View/Download - Maker',
        path: '/posBatchClosure',
      },
      {
        name: 'Batch View/Download - Checker',
        path: '/posBatchClosureApprovals',
      },
      {
        name: 'Batch Management - Maker',
        path: '/bulkPosBatchClosure',
      },
      {
        name: 'Batch Management - Checker',
        path: '/bulkPosBatchClosureApprovals',
      },
    ],
  },
  {
    // Registration-only section: these tabs are shown as direct items under the
    // 'Miscellaneous' category (see menuCategories.items), not as a section header.
    name: 'Standalone Tabs',
    path: '/',
    icon: 'SETTING',
    subRights: [
      {
        name: 'POS Bank Onboarding',
        path: '/posapprovals',
      },
      {
        name: 'Finhub Reports',
        path: '/finHubReports',
      },
    ],
  },
]

// 3-level side-menu grouping: Category (L1) -> Section (L2, from menuItems) -> Item (L3, subRights).
// This only groups the existing sections for display; it does not change any route, path or access rule.
export const menuCategories = [
  {
    name: 'Processors',
    icon: 'BANK',
    sections: ['Entity Config'],
    // Processors shows its tabs directly (no intermediate section header).
    flat: true,
  },
  {
    name: 'Entities',
    icon: 'TRANSACTIONS',
    // Small example/hint label shown next to the category name.
    example: 'merchant',
    sections: [
      'Merchant - Processor Configuration',
      'Smart Routing',
      'Management',
      'Aadhaar Redaction',
      'Onboarding',
      'Bulk Processing',
    ],
  },
  {
    name: 'Settlement & Payout',
    icon: 'SETTLEMENTS',
    sections: [
      'Post Recon Payout',
      'System Settings',
      'Adjustments',
      'Update Records',
      'Fee Package',
      'Payout Configurations',
    ],
  },
  {
    name: 'Risk & Compliance',
    icon: 'LOCK',
    sections: ['Entity Transactions', 'Entity Onboarding', 'FIU Compliance'],
  },
  {
    name: 'Batch Closure',
    icon: 'LAYERS',
    sections: ['POS'],
    // Batch Closure shows its tabs directly (no intermediate section header).
    flat: true,
  },
  {
    name: 'Device Management',
    icon: 'MOBILE',
    sections: ['Device Management'],
    flat: true,
  },
  {
    name: 'Miscellaneous',
    icon: 'OPTIONS',
    sections: ['System Configuration'],
    // Shown directly under the category (no intermediate section header).
    items: [
      { name: 'POS Bank Onboarding', path: '/posapprovals' },
      { name: 'Finhub Reports', path: '/finHubReports' },
    ],
  },
  {
    name: 'Settings',
    icon: 'SETTING',
    sections: ['Access Control'],
  },
]

const getComponents = (item: any) => {
  const name = item?.name
  const path = item?.path.split('/')[1]
  const retData = {
    name: path !== '' ? path : 'default',
    title: item?.name,
    comp: EntityMaster,
  } as any

  switch (name) {
    case 'Entity Master':
      retData.comp = EntityMaster
      break
    case 'Card Mapping':
      retData.comp = CardMapping
      break
    case 'Netbanking Mapping':
      retData.comp = NetbankingMapping
      break
    case 'Merchant Mapping':
      retData.comp = MerchantMapping
      break
    case 'Approvals':
      retData.comp = EntityApprovals
      break
    case 'Devices':
      retData.comp = Devices
      break
    case 'EMS Devices':
      retData.comp = EmsDevices
      break
    case 'Rules':
      retData.comp = RoutingRules
      break
    case 'RoutingApprovals':
      retData.comp = RoutingApprovals
      break
    case 'Create Package':
      retData.comp = Package
      break
    case 'Package To Instrument':
      retData.comp = DynamicRouting //PackageToInstrument
      break
    case 'Package To Merchant Id':
      retData.comp = PackageToMId
      break
    case 'Dynamic Routing':
      retData.comp = DynamicRouting
      break
    case 'File Upload':
      retData.comp = FileUpload
      break
    case 'List Users':
      retData.comp = Users
      break
    case 'Add/Modify User':
      retData.comp = AddUpdateUser
      break
    case 'Add/Modify Group':
      retData.comp = AddUpdateGroup
      break
    case 'Banking Codes':
      retData.comp = BankingCodes
      break
    case 'System Control Approvals':
      retData.comp = SystemControlConfigApprovals
      break
    case 'Bulk Onboarding':
      retData.comp = BulkMerchantOnboarding
      break
    // case 'Merchant Onboarding':
    //   retData.comp = SearchMerchant
    //   break
    case 'Entity Management':
      retData.comp = EntityManagement
      break
    case 'Onboard Entity':
      retData.comp = OnboardEntity
      break
    case 'Checker1 MyQueue':
      retData.comp = MyOnboardedEntityQueue
      break
    case 'My Onboarded EntityDetails':
      retData.comp = MyOnboardedEntityDetails
      break
    case 'Checker1 Queue':
      retData.comp = CheckerQueue
      break
    case 'Checker2 Queue':
      retData.comp = CheckerQueue
      break
    case 'RiskChecker Queue':
      retData.comp = CheckerQueue
      break
    case 'RiskMaker Queue':
      retData.comp = CheckerQueue
      break
    case 'Create Group':
      retData.comp = EntityManagement
      break
    case 'Create Subgroup':
      retData.comp = EntityManagement
      break
    case 'Create Single Entity':
      retData.comp = EntityManagement
      break
    case 'Create Bulk Entities':
      retData.comp = EntityManagement
      break
    case 'Sync Bulk Entities with MAS':
      retData.comp = EntityManagement
      break
    case 'Bulk Merchant Mapping':
      retData.comp = BulkMerchantMapping
      break
    case 'ESS Control Update':
      retData.comp = EssControlUpdate
      break
    case 'Update Config':
      retData.comp = MerchantConfig
      break
    case 'Ledger Mapping':
      retData.comp = LedgerMapping
      break
    case 'Bulk Ledger Mapping':
      retData.comp = BulkLedgerMapping
      break
    case 'Payout Frequency Config':
      retData.comp = PayoutConfig
      break
    case 'Source Account Config':
      retData.comp = SourceAccountConfig
      break
    case 'Risk Config':
      retData.comp = RiskConfig
      break
    case 'CMS Update':
      retData.comp = PayoutCmsUpdate
      break

    case 'Create FeePackage':
      retData.comp = FeePackage
      break
    case 'FeePackage To MID':
      retData.comp = FeePackageToMId
      break
    case 'FeePackage File Upload':
      retData.comp = FeePackageFileUpload
      break
    case 'FeePackage Approvals':
      retData.comp = FeePackageApprovals
      break
    case 'Processing Entity':
      retData.comp = ProcessingEntity
      break
    case 'Credit Debit Adjustment':
      retData.comp = CreditAdjustment
      break
    case 'Approvals':
      retData.comp = EmsApprovals
      break
    case 'Update Config':
      retData.comp = MerchantConfig
      break
    case 'Bulk Merchant Payout Config Update':
      retData.comp = BulkMerchantPayoutConfig
      break
    case 'View Dynamic Hold Settlements':
      retData.comp = OnHoldSettlements
      break
    case 'Merchant payout Config Approvals':
      retData.comp = MerchantPayoutConfigApprovals
      break
    case 'View POS':
      retData.comp = ApprovedPos
      break
    case 'Create Bulk Config':
      retData.comp = EntityManagement
      break
    case 'Create Bulk Cards':
      retData.comp = EntityManagement
      break
    case 'FIU Compliance':
      retData.comp = EntityManagement
      break
    case 'Aadhar Redaction':
      retData.comp = EntityManagement
      break
    case 'Bulk ESS Update':
      retData.comp = BulkEssUpdate
      break
    case 'Create Bulk Users':
      retData.comp = EntityManagement
      break
    case 'Bulk ESS Update':
      retData.comp = BulkEssUpdate
      break
    case 'Create Bulk VPA':
      retData.comp = EntityManagement
      break
    case 'Bulk Store Onboarding':
      retData.comp = EntityManagement
      break
    case 'Bulk Terminal Onboarding':
      retData.comp = EntityManagement
      break
  }

  return retData
}
export const getSubRights = (data: any) => {
  if (data !== undefined && data.length > 0) {
    return data.map((item: any) => getComponents(item))
  }
  return []
}

export const dataExport = [
  {
    id: '1',
    isChecked: true,
    title: 'Excel',
    type: 'XLSX',
  },
  {
    id: '2',
    isChecked: false,
    title: 'Text',
    type: 'TXT',
  },
  {
    id: '3',
    isChecked: false,
    title: 'CSV',
    type: 'CSV',
  },
]

export const exportType = new Map([
  [dataExport[0]?.title, 'XLSX'],
  [dataExport[1]?.title, 'TEXT'],
  [dataExport[2]?.title, 'CSV'],
])
